import styled from 'styled-components';
import { BorderRadius, Height, Width } from '../../types';
import { applyBorderRadius, applyHeight, applyWidth } from '../../utils';

export type RoundedButtonProps = {
  $borderRadius?: BorderRadius;
  $height?: Height;
  $width?: Width;
};

export const RoundedButton = styled.button<RoundedButtonProps>`
  border: 1px solid #ddd;
  padding: 6px 24px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  font-size: 13px;
  ${applyBorderRadius}
  ${applyHeight}
  ${applyWidth}

  :hover {
    background: #f7f7f7;
  }

  :active,
  :focus {
    background: #fff;
    border-color: #ddd;
  }

  :disabled,
  [disabled]:hover {
    color: inherit;
    background: white;
    opacity: 0.4 !important;
    cursor: not-allowed;
  }
`;
